import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { SrxApi } from "../../api/SrxApi";

const usePrintPDF = () => {
  const {
    mutate: printPDF,
    isLoading,
    data: printPDFResponse,
  } = useMutation(
    async ({ url, fileName, payload, downloadOnSuccess = true }) => {
      const response = await SrxApi.post(url, payload, {
        responseType: "blob", 
      });
      const contentType = response?.headers?.["content-type"] || "";
      let responseData = null;

      if (
        response.data instanceof Blob &&
        contentType.includes("application/json")
      ) {
        const text = await response.data.text();
        responseData = JSON.parse(text);
      }

      return {
        blob: response.data,
        headers: response.headers,
        responseData,
        fileName,
        downloadOnSuccess,
      };
    },
    {
      onSuccess: ({ blob, responseData, fileName, downloadOnSuccess }) => {
        if (responseData?.message) {
          toast.success(responseData.message);
          return;
        }

        if (!blob) {
          toast.error("No file received");
          return;
        }
        if (downloadOnSuccess) {
          const fileBlob = new Blob([blob], { type: "application/pdf" });
          const fileUrl = window.URL.createObjectURL(fileBlob);

          const link = document.createElement("a");
          link.href = fileUrl;
          link.download = fileName || "State_Destruction_Pdf.pdf";

          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(fileUrl);

          toast.success("PDF Exported successfully!");
          
        }
      },

      onError: async (error) => {
        let errorMessage = "Failed to export file";
      
        if (error?.response?.data) {
          const data = error.response.data;

          if (data instanceof Blob && data.type === "application/json") {
            const text = await data.text();
            const json = JSON.parse(text);
            if (json.message) errorMessage = json.message;
          } 
          else if (typeof data === "object" && data.message) {
            errorMessage = data.message;
          } 
          else if (typeof data === "string") {
            errorMessage = data;
          }
        } else if (error?.message) {
          errorMessage = error.message;
        }
      
        toast.error(errorMessage);
      }
    }
  );

  return {
    printPDF,
    isPrintPDFLoading: isLoading,
    printPDFResponse,
  };
};

export default usePrintPDF;